<template>
    <div class="page">
        <div class="item" v-for="(item, index) in list" :key="index">
            <div class="title">{{ item.title }}</div>
            <div v-if="item.type === 'text'" class="size" style="text-indent: 2em;">{{ item.content }}</div>
            <div v-else-if="item.type==='list'"  v-for="(childItem,childIndex) in item.content" :key="childItem.id + childIndex" :style="{marginBottom:childIndex!=item.content.length-1?'8px':''}">
                <div class="size" :style="{color:childItem.color?childItem.color:''}">{{ `${childIndex+1}、${childItem.value}` }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [{
                title: '确保安全',
                type: 'text',
                content: '举报违规操作行为时，应该在确保处在安全的情况下进行，不得在妨碍安全或制造险情的情况下拍照。'
            }, {
                title: '实名举报',
                type: 'list',
                content: [{
                    id: 'real',
                    value: '举报为实名举报，后台会记录举报人账号的真实姓名、身份信息和联系方式。'
                }, {
                    id: 'real',
                    value: '在有需要时协助公司开展调查工作。'
                }, {
                    id: 'real',
                    value: '举报人身份信息，公司将严格保密。',
                    color:'#EF1B1B'
                }]
            }, {
                title: '开启定位',
                type: 'text',
                content: '举报违规操作行为时，需要开启手机定位功能。'
            }, {
                title: '证据规范',
                type: 'list',
                content: [{
                    id: 'normalisation',
                    value: '至少需要提交一个照片或一个视频作为违规证据提交。'
                }, {
                    id: 'normalisation',
                    value: '照片举报:照片能清楚体现出违规事实。'
                }, {
                    id: 'normalisation',
                    value: '视频举报:需拍摄最小时长不小于5秒，最大时长不超过20秒的连续、不间断且能记录违规事实的视频。'
                }, {
                    id: 'normalisation',
                    value: '拍摄图片或视频需能清晰记录违规车辆号牌、外观/人员的面貌以及违法事实，并包含周边环境情况。'
                }, {
                    id: 'normalisation',
                    value: '不符合上述要求的，公司将不予采纳。'
                }]
            }, {
                title: '如实举报',
                type: 'text',
                content: '举报应当如实提供相关信息，对多次举报失实、恶意举报的举报人，经查证属实的，公司不再受理其举报。故意捏造违法事实陷害他人、以举报为手段敲诈勒索，构成违法犯罪的，依据公司规章制度及国家法律法规，给予相应的处理。'
            }, {
                title: '举报方式',
                type: 'text',
                content: '本平台只是接收交通违法举报的途径之一，举报人也可通过其他渠道完成举报。'
            }, {
                title: '最终解释权',
                type: 'text',
                content: '其它未尽事宜，深圳市中永物流有限公司具有最终解释权。'
            }]
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.page {
    background: #F8F8F8;
    height: 100%;
    overflow: auto;
    padding: 24px 12px;

    .item {
        margin-bottom: 24px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 1px rgba(204, 181, 159, 0.1);
        border-radius: 8px;
        border: 1px solid #E3E3E3;
        padding: 16px;
        position: relative;

        .title {
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translateX(-50%);
            height: 32px;
            line-height: 32px;
            background: #FFBD2D;
            border-radius: 8px;
            padding: 0px 24px;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
        }

        .size {
            font-weight: 400;
            font-size: 14px;
            color: #A8A29C;
            line-height: 22px;
        }
    }
}
</style>